import { parseJwt } from '@digital/ui';
import { isNull, isUndefined } from 'lodash';
import { useLayoutEffect, useState } from 'react';

interface JwtPayload {
  name: string;
  id: string;
  isMRN: boolean;
  codigoUsuario: string;
  exp: number;
  perfis: string[] | string;
}

export const getJwt = () => localStorage.idtoken;

export const getGraphJwt = () => localStorage['graph.access.token'];

export const getJwtPayload = () => parseJwt<JwtPayload>(getJwt());

export const setGraphJwt = (token: string | null) => (localStorage['graph.access.token'] = token);

export const setConnectorJwt = (token: string | null) => (localStorage['connector.access.token'] = token);

export const getLoggedUsername = () => {
  const jwt = getJwtPayload();
  return jwt ? decodeURIComponent(escape(jwt.name)) : decodeURIComponent(escape('AntÃ´nio Fagundes'));
};

export const getExpirationTime = () => {
  const jwt = getJwtPayload();
  return jwt ? jwt.exp : 0;
};

export const getLoggedId = () => {
  const jwt = getJwtPayload();
  return jwt ? jwt.id : undefined;
};

export const getLoggedIsMRN = () => {
  return localStorage.getItem('isMRN') == 'true' ? true : false;
};

export const getCodigoUsuario = () => {
  return localStorage.getItem('codigoUsuario');
};
export const getUrlUsuario = () => {
  return localStorage.getItem('url');
};

export const GetFileExtension = (nome: string) => {
  var re = /(?:\.([^.]+))?$/;
  var ext = re.exec(nome)[1];
  if (ext !== undefined) return ext.toLowerCase();
  return '';
};

export const imageFormats = ['png', 'jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp'];

export function uniqueArray(listResult: any[]) {
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  var unique = listResult.filter(onlyUnique);

  return unique;
}

export function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

export const isNullOrUndefined = (value: any) => {
  if(isUndefined(value) || isNull(value)) return true;
  return false;
}
